import { TipoAtendimentoEnum } from "../enums/tipoAtendimento";

const TIPO_ATENDIMENTO_LABELS: Record<TipoAtendimentoEnum, string> = {
  [TipoAtendimentoEnum.LOJA]: "Loja",
  [TipoAtendimentoEnum.DOMICILIO]: "Delivery",
  [TipoAtendimentoEnum.ITINERANTE]: "Itinerante",
};

export function getTipoAtendimentoLabel(tipo?: TipoAtendimentoEnum) {
  if (!tipo) return "";

  return TIPO_ATENDIMENTO_LABELS[tipo] ?? "";
}
